export const getIsProduction = (): boolean => import.meta.env.VITE_IS_PROD === 'true';
export const getDropboxSignClientID = (): string => import.meta.env.VITE_DROPBOX_SIGN_CLIENT_ID;
